
































































import EmphasysRow from "@/components/Atoms/emphasys-row.vue";
import IconRow from "@/components/Atoms/icon-row.vue";
import RefundAttentionAdviser from "@/components/Organisms/RefundNew/RefundAttentionAdviser.vue";
import RefundInvoiceAdviser from "@/components/Organisms/RefundNew/RefundInvoiceAdviser.vue";
import { defineComponent } from "vue";

import AcupunturaPanel from "@/components/Organisms/RefundNew/topics/AcupunturaPanel.vue";
import ConsultasPanel from "@/components/Organisms/RefundNew/topics/ConsultasPanel.vue";
import ExamesPanel from "@/components/Organisms/RefundNew/topics/ExamesPanel.vue";
import FisioterapiaPanel from "@/components/Organisms/RefundNew/topics/FisioterapiaPanel.vue";
import InternacoesPanel from "@/components/Organisms/RefundNew/topics/InternacoesPanel.vue";
import OdontologiaPanel from "@/components/Organisms/RefundNew/topics/OdontologiaPanel.vue";
import PanelTitle from "@/components/Organisms/RefundNew/topics/PanelTitle.vue";
import VacinasPanel from "@/components/Organisms/RefundNew/topics/VacinasPanel.vue";

import { mapState } from "vuex";

/**
 * @prop {Boolean} isOpen
 * @Event {( Array<{ label: string, isActive: boolean }> ) => void} change
 */
export default defineComponent({
  components: {
    EmphasysRow,
    IconRow,
    RefundInvoiceAdviser,
    RefundAttentionAdviser,
    PanelTitle,
    ConsultasPanel,
    ExamesPanel,
    VacinasPanel,
    AcupunturaPanel,
    FisioterapiaPanel,
    InternacoesPanel,
    OdontologiaPanel
  },
  props: {
    isOpen: {
      type: Boolean
    }
  },
  computed: {
    ...mapState("refund", ["newRefund"])
  },
  methods: {
    onContinue() {
      this.$router.push({
        name: "refund.new.create.credit-inform"
      });
    }
  },
  mounted() {
    if (!this.newRefund || this.newRefund.type === null) {
      this.$router.push({ name: "refund.new.create" });
      return;
    }
  }
});
